/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Ott-common */
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { noOp } from '../../utils/functions';

/* Styles */
import './SeeAllCardLive.scss';

function SeeAllCardLive({
  focused,
  className = '',
  onMouseEnter = noOp,
  onMouseDown = noOp,
}) {
  return (
    <InteractiveElement
      className={`dtv-html5-c-see-all-card-live ${
        focused ? 'dtv-html5-c-see-all-card-live--focused' : ''
      } ${className}`}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      <FormattedMessage id="seeAll.title" />
    </InteractiveElement>
  );
}

SeeAllCardLive.propTypes = {
  focused: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

export default memo(withInteractiveFocusable()(memo(SeeAllCardLive)));
